import workerManager from "_src/engine/worker_manager.js";
import {messageType} from "_src/engine/ipc.js";
import workerPool from "_src/engine/worker_pool";

import zstdCoder from "_zstdCoderModule";
import LoaderBase from "_src/engine/loaders/loader_base";
import {readChunk} from "_src/engine/loaders/utils"
import config from "_src/config";

export default class ZStdLoader extends LoaderBase {

  constructor(verbose) {
    super();
    this._verbose = verbose;
  }

  _checkVerbosity() {
    return this._verbose;
  }

  async loadMain(buffer) {
    const coder = await zstdCoder.getCoder();
    const chunkData = readChunk(buffer, coder);
    const geometry = this.prepareGeometry(chunkData);

    return geometry;
  }

  async loadWorker(buffer, tid) {
    const message = {
      type : messageType.PARSE_ZSTD,
      file : buffer
    };
    const transfer = [buffer];
    const chunkData = (await workerManager.sendMessage(message, transfer, tid)).data;
    const geometry = this.prepareGeometry(chunkData);

    return geometry;
  }

  stopLoading() {
    workerManager.terminateByType(messageType.PARSE_ZSTD);
  }

  cleanup() {
    workerPool.cleanup(messageType.PARSE_ZSTD);
    return Promise.resolve();
  }

}

export async function initZSTDWorkers() {
  const promises = [];
  for (let i=0; i<config.maxWorkersPerTask; i++) {
    const message = {
      type : messageType.INIT_ZSTD,
      tid : workerManager.generateUniqueID(),
    };
    promises.push(workerManager.sendMessage(message, [], message.tid));
  }

  await Promise.all(promises);
}
